import {Box} from '@mantine/core';
import Head from 'next/head';
import {useRouter} from 'next/router';
import type {FC} from 'react';
import {PmarkTextComponent} from './PmarkTextComponent';

export const PmarkPage: FC = () => {
  const router = useRouter();
  const currentUrl = `https://gaishishukatsu.com/${decodeURI(router.pathname)}`;

  return (
    <>
      <Head>
        <title key="title">個人情報の取扱い</title>
        <meta key="og:title" property="og:title" content="個人情報の取扱い" />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <link rel="canonical" href={currentUrl} key="canonical" />
      </Head>
      <Box className="w-full max-w-[664px]">
        <h1 className="hidden">個人情報の取扱い</h1>
        <PmarkTextComponent />
      </Box>
    </>
  );
};
